import { safeDeleteSheet } from "@/lib/office-helpers";

export async function startProject7(): Promise<void> {
  await Excel.run(async (context) => {
    await safeDeleteSheet(context, "Ventas actuales T1");
    await safeDeleteSheet(context, "Objetivo de ventas T1");
    await safeDeleteSheet(context, "Inventario de alimentos");
    await safeDeleteSheet(context, "Tabla dinámica");

    // ─── SHEET 1: Ventas actuales T1 ───
    const sheet1 = context.workbook.worksheets.add("Ventas actuales T1");

    const ventasHeaders: string[] = [
      "Sitio de camiones",
      "Opciones de menú",
      "Enero",
      "Febrero",
      "Marzo",
      "Total",
    ];

    const ventasData: (string | number)[][] = [
      ["Campus Universitario", "Hamburguesa", 2567, 3340, 2733, 8640],
      ["Campus Universitario", "Hot Dog", 1565, 1622, 1437, 4624],
      ["Campus Universitario", "Sandwich de pollo", 6587, 4157, 5595, 16339],
      ["Campus Universitario", "Sandwich de pescado", 5915, 7608, 39512, 53035],
      ["Campus Universitario", "Taco", 3873, 3754, 3434, 11061],
      ["Campus Universitario", "Burrito", 1543, 1654, 1234, 4431],
      ["Campus Universitario", "Costilla", 4567, 6543, 4656, 15766],
      ["Centro de la ciudad", "Hamburguesa", 2012, 2300, 2323, 6635],
      ["Centro de la ciudad", "Hot Dog", 1700, 1543, 1594, 4837],
      ["Centro de la ciudad", "Sandwich de pollo", 1989, 1888, 1989, 5866],
      ["Centro de la ciudad", "Sandwich de pescado", 1388, 1433, 1376, 4197],
      ["Centro de la ciudad", "Taco", 1100, 1200, 1321, 3621],
      ["Centro de la ciudad", "Burrito", 1010, 1211, 1432, 3653],
      ["Centro de la ciudad", "Costilla", 2100, 2320, 3210, 7630],
      ["Campus escuela secundaria", "Sandwich de pollo", 4410, 4321, 4123, 12854],
      ["Campus escuela secundaria", "Sandwich de pescado", 2134, 2323, 2156, 6613],
      ["Campus escuela secundaria", "Taco", 2456, 2476, 2898, 7830],
      ["Campus escuela secundaria", "Burrito", 2345, 3214, 2314, 7873],
      ["Campus escuela secundaria", "Costilla", 1200, 3211, 2334, 6745],
      ["Parque industrial", "Hamburguesa", 3798, 4200, 4122, 12120],
      ["Parque industrial", "Hot Dog", 4400, 4532, 4112, 13044],
      ["Parque industrial", "Sandwich de pollo", 5500, 5693, 5723, 16916],
      ["Parque industrial", "Sandwich de pescado", 5656, 5743, 5874, 17273],
      ["Parque industrial", "Taco", 4400, 4765, 4887, 14052],
      ["Parque industrial", "Burrito", 4567, 5432, 3456, 13455],
      ["Parque industrial", "Costilla", 4566, 7654, 5654, 17874],
      ["Zoológico", "Hamburguesa", 2012, 2300, 2323, 6635],
      ["Zoológico", "Hot Dog", 1700, 1543, 1594, 4837],
      ["Zoológico", "Sandwich de pollo", 1989, 1888, 1989, 5866],
      ["Zoológico", "Sandwich de pescado", 1388, 1433, 1376, 4197],
      ["Zoológico", "Taco", 1100, 1200, 1321, 3621],
      ["Zoológico", "Burrito", 1010, 1211, 1432, 3653],
      ["Zoológico", "Costilla", 2100, 2320, 3210, 7630],
    ];

    const table1 = sheet1.tables.add("A1:F1", true);
    table1.name = "VentasActualesT1";
    table1.getHeaderRowRange().values = [ventasHeaders];
    table1.style = "TableStyleMedium3";
    table1.rows.add(undefined, ventasData);

    // Currency format for Enero–Total (C:F)
    const ventasLastRow = ventasData.length + 1; // +1 for header
    sheet1
      .getRange(`C2:F${ventasLastRow}`)
      .numberFormat = Array(ventasData.length).fill(["$#,##0.00", "$#,##0.00", "$#,##0.00", "$#,##0.00"]);

    // Label for Task 2 — merged H10:J11 with text wrap (3 cols x 2 rows)
    sheet1.getRange("H10:J11").merge();
    sheet1.getRange("H10").values = [
      ["Número de camiones con ventas de hamburguesas >$2,500:"],
    ];
    sheet1.getRange("H10").format.font.bold = true;
    sheet1.getRange("H10").format.horizontalAlignment = "Left";
    sheet1.getRange("H10").format.verticalAlignment = "Center";
    sheet1.getRange("H10").format.wrapText = true;
    sheet1.getRange("H:J").format.columnWidth = 80;

    // H12 empty (student COUNTIFS) — bordered
    sheet1.getRange("H12").format.borders.getItem("EdgeBottom").style = "Continuous";
    sheet1.getRange("H12").format.borders.getItem("EdgeTop").style = "Continuous";
    sheet1.getRange("H12").format.borders.getItem("EdgeLeft").style = "Continuous";
    sheet1.getRange("H12").format.borders.getItem("EdgeRight").style = "Continuous";

    sheet1.getUsedRange().format.autofitColumns();

    await context.sync();

    // ─── SHEET 2: Objetivo de ventas T1 ───
    const sheet2 = context.workbook.worksheets.add("Objetivo de ventas T1");

    const objHeaders: string[] = [
      "Ubicación",
      "Enero",
      "Febrero",
      "Marzo",
      "Total",
    ];

    const objData: (string | number)[][] = [
      ["Campus Universitario", 20000, 20000, 15000, 55000],
      ["Centro de la ciudad", 12000, 13000, 14000, 39000],
      ["Campus de la escuela secundaria", 13000, 14000, 15000, 42000],
      ["parque Industrial", 33000, 38000, 35000, 106000],
      ["Zoológico", 11000, 12000, 13000, 36000],
    ];

    const table2 = sheet2.tables.add("A1:E1", true);
    table2.name = "ObjetivoVentasT1";
    table2.getHeaderRowRange().values = [objHeaders];
    table2.style = "TableStyleMedium3";
    table2.rows.add(undefined, objData);

    // Enable total row
    table2.showTotals = true;
    table2.columns.getItem("Total").getTotalRowRange().formulas = [
      ["=SUBTOTAL(109,[Total])"],
    ];

    // Number format
    sheet2
      .getRange("B2:E7")
      .numberFormat = Array(6).fill(["#,##0.00", "#,##0.00", "#,##0.00", "#,##0.00"]);

    sheet2.getUsedRange().format.autofitColumns();

    await context.sync();

    // ─── SHEET 3: Inventario de alimentos ───
    const sheet3 = context.workbook.worksheets.add("Inventario de alimentos");

    const invHeaders: string[] = [
      "Alimentos",
      "Cantidad (casos)",
      "Costo Unitario",
      "Total",
    ];

    const invData: (string | number)[][] = [
      ["Carne de hamburguesa", 10, 27.99, 37.99],
      ["Hot Dogs", 16, 24.65, 40.65],
      ["Panes de Hamburguesa", 10, 22.55, 32.55],
      ["Panes de Hot Dog", 16, 19.99, 35.99],
      ["Queso rallado", 6, 49.65, 55.65],
      ["Palomitas de maíz - regular", 20, 12.75, 32.75],
      ["Palomitas de maíz -  cheddar blanco", 20, 15.75, 35.75],
      ["Lechuga", 5, 30.00, 35.00],
      ["Tomates", 5, 40.00, 45.00],
      ["Cebolla", 5, 50.00, 55.00],
      ["Coca-cola", 30, 10.00, 40.00],
      ["Dr. Pepper", 30, 10.00, 40.00],
      ["Cerveza de raíz", 30, 10.00, 40.00],
      ["7-Up", 30, 10.00, 40.00],
      ["Orange Crush", 30, 10.00, 40.00],
      ["Taco de carne sazonada", 6, 74.35, 80.35],
      ["Agua embotellada", "", 4.00, 4.00],
      ["Papas fritas", 12, 12.00, 24.00],
      ["Papas fritas BBQ", 12, 12.00, 24.00],
      ["Frituras de maíz", 12, 13.00, 25.00],
      ["Pepinillos", 3, 49.50, 52.50],
      ["Paquetes de dulces", 6, 32.65, 38.65],
      ["paquetes de mayonesa", 6, 26.86, 32.86],
      ["Paquetes de mostaza", 6, 27.55, 33.55],
      ["Paquetes de catsup", 6, 27.45, 33.45],
      ["Paquetes de Salsa Tártara", 6, 30.00, 36.00],
      ["Rebanadas de queso", 4, 64.55, 68.55],
      ["Galletas de chispas de chocolate", 7, 39.35, 46.35],
      ["Galletas de avena y pasas", 2, 31.85, 33.85],
      ["Galletas de mantequilla de maní", 4, 46.15, 50.15],
      ["Salchicha", 3, 43.75, 46.75],
      ["Salsa de queso para nachos", 2, 24.49, 26.49],
      ["Frituras para nachos", 2, 15.09, 17.09],
      ["Manzanas", 2, 39.95, 41.95],
      ["Naranjas", 2, 29.00, 31.00],
      ["Pepinillos", 3, 49.50, 52.50],
      ["Chucrut", 2, 39.95, 41.95],
      ["Pechuga de pollo(sin hueso)", 3, 51.65, 54.65],
      ["Costillas", 4, 66.25, 70.25],
      ["Ensalada de papas", 6, 30.75, 36.75],
      ["Ensalada de col", 6, 25.40, 31.40],
      ["Filetes de pescado", 2, 33.65, 35.65],
      ["Papas fritas", 20, 20.60, 40.60],
      ["Aros de cebolla", 7, 57.65, 64.65],
      ["Carne de hamburguesa", 10, 27.99, 37.99],
      ["Helado - Vanilla", 3, 36.50, 39.50],
      ["Helado - Chocolate", 3, 38.45, 41.45],
      ["Conos de Waffles", 9, 38.49, 47.49],
      ["Rodajas de piña", 3, 36.99, 39.99],
      ["Taco de carne sazonada", 6, 74.35, 80.35],
      ["Tortillas de taco (maíz)", 6, 33.05, 39.05],
      ["Queso rallado", 6, 49.65, 55.65],
      ["Frijoles pintos", 6, 14.85, 20.85],
      ["Arroz español", 14, 20.64, 34.64],
      ["Tortillas de harina", 6, 32.45, 38.45],
      ["Burrito mix", 6, 60.79, 66.79],
    ];

    const table3 = sheet3.tables.add("A1:D1", true);
    table3.name = "InventarioAlimentos";
    table3.getHeaderRowRange().values = [invHeaders];
    table3.style = "TableStyleMedium3";
    table3.rows.add(undefined, invData);

    // Currency format for Costo Unitario and Total (C:D)
    const invLastRow = invData.length + 1;
    sheet3
      .getRange(`C2:D${invLastRow}`)
      .numberFormat = Array(invData.length).fill(["$#,##0.00", "$#,##0.00"]);

    sheet3.getUsedRange().format.autofitColumns();

    await context.sync();

    // ─── SHEET 4: Tabla dinámica ───
    const sheet4 = context.workbook.worksheets.add("Tabla dinámica");

    // Create pivot table from Ventas actuales T1
    const ventasSheet = context.workbook.worksheets.getItem("Ventas actuales T1");
    const srcRange = ventasSheet.getRange(`A1:F${ventasLastRow}`);

    const pvt = sheet4.pivotTables.add(
      "pvtAlimentos",
      srcRange,
      sheet4.getRange("A2"),
    );

    pvt.hierarchies.load("items/name");
    await context.sync();

    // Rows: Opciones de menú, then Sitio de camiones
    pvt.rowHierarchies.add(pvt.hierarchies.getItem("Opciones de menú"));
    pvt.rowHierarchies.add(pvt.hierarchies.getItem("Sitio de camiones"));

    // Values: Sum of Enero, Febrero, Marzo
    const dEnero = pvt.dataHierarchies.add(
      pvt.hierarchies.getItem("Enero"),
    );
    dEnero.summarizeBy = "Sum";

    const dFebrero = pvt.dataHierarchies.add(
      pvt.hierarchies.getItem("Febrero"),
    );
    dFebrero.summarizeBy = "Sum";

    const dMarzo = pvt.dataHierarchies.add(
      pvt.hierarchies.getItem("Marzo"),
    );
    dMarzo.summarizeBy = "Sum";

    // Disable grand totals by default (student enables column totals in Task 5)
    pvt.layout.showColumnGrandTotals = false;
    pvt.layout.showRowGrandTotals = false;

    await context.sync();

    // Activate first sheet
    sheet1.activate();
    sheet1.getRange("A1").select();

    await context.sync();
  });
}
